import React from 'react';
import './Hero.css';
import Checkout from '../dashboard/Checkout';

function Hero({}) {
    return (
        <div className='dashBoard'>
            <Checkout />
            
        </div>
    )
}

export default Hero
